// This file was automatically generated from appchart.refpanel.providers.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.providers');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.careTeamProviders');
goog.require('el8.template.ptdata.ptProviders');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.providers.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length) {
    output.append('<ol id="providers-summary-list">');
    var itemList5698 = opt_data.items;
    var itemListLen5698 = itemList5698.length;
    for (var itemIndex5698 = 0; itemIndex5698 < itemListLen5698; itemIndex5698++) {
      var itemData5698 = itemList5698[itemIndex5698];
      el8.template.appchart.refpanel.providers.summaryItem({item: itemData5698}, output);
    }
    output.append('</ol>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.providers.summaryItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="provider-entry ', (el8Globals.FEATURES.PLR4Everyone) ? 'el8LHSProviderBullets el8LHSProviderItem ' : 'el8LHSProviderBullets', ' el8ItemHover am-highlight more-actions-trigger" data-id="', soy.$$escapeHtml(opt_data.item.id), '">', (! el8Globals.FEATURES.PLR4Everyone) ? '<span class="provider-sort-handle el8Gripper"></span>' : '', '<div class="el8ItemButtonContainer">', (! opt_data.item.treatmentReason) ? '<button tabindex="-1" type="button" class="el8button el8ItemButton el8FirstButton el8333 add-treating-note ebs-btn ebs-btn-default">Add Note</button>' : '', '<button tabindex="-1" type="button" class="el8button el8ActionButton ', (! opt_data.item.treatmentReason) ? 'el8LastButton' : '', ' ebs-btn ebs-btn-default">Actions<span class="el8ButtonDropdownIcon"></span></button></div><p><a class="providers-summary-list-trigger">');
  el8.template.ptdata.ptProviders.refpanelSummary(opt_data.item, output);
  output.append('</a>', (el8Globals.FEATURES.PLR4Everyone && opt_data.item.physician.phone) ? '<span class="ml5">(T) ' + soy.$$escapeHtml(opt_data.item.physician.phone) + '</span>' : '', '</p>');
  if (opt_data.item.treatmentReason) {
    el8.template.appchart.refpanel.providers.treatingNoteField(opt_data.item, output);
  } else {
    output.append('<div class="treating-note-holder"></div>');
  }
  output.append('</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.providers.summaryCareTeam = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length) {
    output.append('<ol id="care-team-summary-list">');
    var itemList5743 = opt_data.items;
    var itemListLen5743 = itemList5743.length;
    for (var itemIndex5743 = 0; itemIndex5743 < itemListLen5743; itemIndex5743++) {
      var itemData5743 = itemList5743[itemIndex5743];
      if (itemData5743.isCareTeamModel) {
        el8.template.appchart.refpanel.providers.summaryCareTeamItem({item: itemData5743}, output);
      } else {
        el8.template.appchart.refpanel.providers.summaryItem({item: itemData5743}, output);
      }
    }
    output.append('</ol>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.providers.summaryCareTeamItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="care-team-entry el8LHSProviderBullets el8LHSProviderItem el8ItemHover am-highlight more-actions-care-team-trigger" data-id="', soy.$$escapeHtml(opt_data.item.id), '"><div class="el8ItemButtonContainer">', (! opt_data.item.isCurrentUser && ! opt_data.item.note) ? '<button tabindex="-1" type="button" class="el8button el8ItemButton el8FirstButton el8333 add-care-team-provider-note">Add Note</button>' : '', '<button tabindex="-1" type="button" class="el8button el8ActionButton ', (! opt_data.item.note) ? 'el8LastButton' : '', '">Actions<span class="el8ButtonDropdownIcon"></span></button></div><p><a class="providers-summary-list-trigger">');
  el8.template.ptdata.careTeamProviders.refpanelSummary(opt_data.item, output);
  output.append('</a></p>');
  if (opt_data.item.note) {
    el8.template.appchart.refpanel.providers.careTeamMemberNote(opt_data.item, output);
  } else {
    output.append('<div class="care-team-note-holder"></div>');
  }
  output.append('</div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.providers.addNewTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LHSButtonContainer"><button type="button" class="el8button add-provider-trigger el8ItemButton el8Show ebs-btn ebs-btn-default">+ Add Provider</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.providers.careTeamTriggerSet = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LHSButtonContainer"><p><button type="button" class="el8button add-provider-trigger el8ItemButton el8Show">+ Add Provider</button><button type="button" class="el8button manage-care-team-trigger el8ItemButton el8Show">View All Providers</button></p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.providers.addNewForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form class="new-provider-form"><div class="el8FieldSection"><label class="el8label el8FieldProvider el8FieldRequired"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Name:</span></label><div class="ml75 el8TextareaWrap name-field"></div></div><div class="el8FieldSection specialty-field"><label class="el8label el8FieldProvider el8FieldRequired"><span class="el8FieldSection">Specialty:</span></label><div class="ml75"><ol class="specialties-list"></ol><textarea type="text" class="w100" name="specialties"></textarea></div></div><div class="el8FieldSection"><label class="el8label el8FieldProvider el8FieldRequired"><span class="el8FieldSection">Note:</span></label><div class="ml75 el8TextareaWrap"><textarea type="text" class="w100" name="treatmentReason"></textarea></div></div></form><span class="new-provider-form-buttons clearfix el8NewProviderButtons"></span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.providers.treatingNoteField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LHSTreatingNote treating-note-field" data-id="', soy.$$escapeHtml(opt_data.id), '"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.providers.careTeamMemberNote = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LHSCareTeamProviderNote care-team-note-field" data-id="', soy.$$escapeHtml(opt_data.id), '"></div>');
  if (!opt_sb) return output.toString();
};
